exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright-mask[data-v-36cacdab]{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3;pointer-events:none}.copyright-mask .copyright-box[data-v-36cacdab]{position:absolute;color:#f10;opacity:0;font-size:12px}", ""]);

// exports
